import React from "react";
import { Container } from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import AddSiteConfigurationsContainer from "./AddSiteConfigurationsContainer";

import UpdateSiteConfigurationsContainer from "./UpdateSiteConfigurationsContainer";
import type { UpdateSiteConfigurationsContainerProps } from "./UpdateSiteConfigurationsContainer";

export type SiteConfigurationViewProps = {
  action?: "update" | "add";
  SettingsVariables?: UpdateSiteConfigurationsContainerProps["SettingsVariables"];
  current?: string;
};

// SCRUM-1225: SettingsRequired / SettingsOptional were threaded through here to
// both children and read by neither — UpdateSiteConfigurationsContainer even
// received `SettingsRequired={[]}` with the comment "not used here".
const SiteConfigurationView = ({
  action,
  SettingsVariables,
  current,
}: SiteConfigurationViewProps) => {
  return (
    <>
      <SimpleHeader name="Site Configuration" parentName="Site Tools" />
      <Container className="mt--6" fluid>
        {action === "add" ? (
          <AddSiteConfigurationsContainer current={current} action={action} />
        ) : (
          <UpdateSiteConfigurationsContainer
            SettingsVariables={SettingsVariables}
            current={current}
            action={action}
          />
        )}
      </Container>
    </>
  );
};

export default SiteConfigurationView;
